"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var PendingNewVersion = /** @class */ (function (_super) {
    tslib_1.__extends(PendingNewVersion, _super);
    function PendingNewVersion(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onCancel = function () {
            _this.dismiss();
        };
        _this.onConfirm = function () {
            var onConfirm = _this.props.onConfirm;
            onConfirm();
        };
        return _this;
    }
    PendingNewVersion.prototype.dismiss = function () {
        var onDismiss = this.props.onDismiss;
        onDismiss();
    };
    PendingNewVersion.prototype.getTransitionClasses = function () {
        return {
            enter: theme.messageEnter,
            enterActive: theme.messageEnterActive,
            exit: theme.messageLeave,
            exitActive: theme.messageLeaveActive
        };
    };
    PendingNewVersion.prototype.render = function () {
        var _a = this.props, pendingNewVersion = _a.pendingNewVersion, title = _a.title, text = _a.text;
        return (React.createElement(ui_1.Portal, null,
            React.createElement(react_transition_group_1.CSSTransition, { in: pendingNewVersion, unmountOnExit: true, classNames: this.getTransitionClasses(), timeout: 200 },
                React.createElement(ui_1.ConfirmPopMessage, { nostrip: true, className: theme.pendingNewVersion, title: title, text: text, confirmText: "Update", cancelText: "Ignore", onCancelClick: this.onCancel, onConfirmClick: this.onConfirm }))));
    };
    PendingNewVersion.defaultProps = {
        title: "A new update is now available",
        text: React.createElement("div", null,
            "Get the latest version to optimize",
            React.createElement("br", null),
            "the compatibility of the system")
    };
    return PendingNewVersion;
}(React.PureComponent));
exports.default = PendingNewVersion;
